<script setup lang="ts">
import {ref} from 'vue';
import {useQuasar} from 'quasar';
import {useSessionStore} from '@/store';
import {handleApiRequest} from '@/api/handleApiRequest.ts';
import {getEducationAsset} from '@/api/endpoints/calendarWeb.ts';
import {loadEpub} from '@/utils/zbdev.epub.ts';
import {getEpubforMessageAssistant} from '@/api/endpoints/messagesWeb.ts';

const props = defineProps({
  ePubId: {
    type: Number,
    required: false
  },
  ePubUrl: {
    type: String,
    required: false
  }
});

const showDialog = defineModel({
  type: Boolean,
  default: false,
  required: true
});

const $q = useQuasar(),
  sessionStore = useSessionStore();

const isLoading = ref<boolean>(false);

async function onBeforeShow() {

  isLoading.value = true;

  $q.loading.show();

  const languageId = sessionStore.user?.preferredLanguageId;

  if (props.ePubId && languageId) {
    const response = await handleApiRequest(() => getEducationAsset(props.ePubId, languageId), null, $q);

    if (response?.result) {
      loadEpub(response.result.epub, 'renderEPub');
    }
  } else if(props.ePubUrl) {
    const response = await handleApiRequest(() => getEpubforMessageAssistant(props.ePubUrl), null, $q);

    if (response?.result) {
      loadEpub(response.result.epub, 'renderEPub');
    }
  } else {
    showDialog.value = false;
  }

  isLoading.value = false;

  $q.loading.hide();
}



function onHide(){
  isLoading.value = false;
}

</script>

<template>
  <zbm-dialog v-model="showDialog"
              @before-show="onBeforeShow"
              @hide="onHide"
              :close-button="true" :type="$zb.enums.DialogType.epub">

    <!-- Dialog Content -->
    <template #default>

      <!-- Body -->
      <div class="row q-dialog__body">
        <div class="col"
             id="renderEPub" />
      </div>
    </template>
  </zbm-dialog>
</template>

<style scoped lang="scss"></style>
